import { render, staticRenderFns } from "./security-auditor.vue?vue&type=template&id=0f70afa7&scoped=true"
import script from "./security-auditor.vue?vue&type=script&lang=js"
export * from "./security-auditor.vue?vue&type=script&lang=js"
import style0 from "./security-auditor.vue?vue&type=style&index=0&id=0f70afa7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70afa7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f70afa7')) {
      api.createRecord('0f70afa7', component.options)
    } else {
      api.reload('0f70afa7', component.options)
    }
    module.hot.accept("./security-auditor.vue?vue&type=template&id=0f70afa7&scoped=true", function () {
      api.rerender('0f70afa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/security-auditor.vue"
export default component.exports